import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signUp } from "../config/firebase";
import { authErrorForUser } from "../utils/authUserMessages";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState(""); // bar_owner, artist, or bar_admin
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Validate role selection
    if (!role) {
      setError("Please select a role");
      return;
    }

    // Validate name
    if (!name.trim()) {
      setError("Please enter your name");
      return;
    }

    // Validate passwords match
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const result = await signUp(email, password, name, role);

      if (!result.success) {
        setError(authErrorForUser(result.error, "signup"));
        setLoading(false);
        return;
      }

      setSuccess(result.message);

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setError(authErrorForUser(err, "signup"));
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        {!success ? (
          <>
            <h2>Create Account</h2>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit}>
              {/* Role Selection */}
              <div className="form-group">
                <label>I am a:</label>
                <div className="role-selection-buttons">
                  <button
                    type="button"
                    className={`role-button ${
                      role === "bar_owner" ? "selected" : ""
                    }`}
                    onClick={() => setRole("bar_owner")}
                    disabled={loading}
                  >
                    Bar Owner
                  </button>
                  <button
                    type="button"
                    className={`role-button ${
                      role === "artist" ? "selected" : ""
                    }`}
                    onClick={() => setRole("artist")}
                    disabled={loading}
                  >
                    Artist
                  </button>
                  <button
                    type="button"
                    className={`role-button ${
                      role === "bar_admin" ? "selected" : ""
                    }`}
                    onClick={() => setRole("bar_admin")}
                    disabled={loading}
                  >
                    Bar Admin
                  </button>
                </div>
              </div>

              {/* Show signup form for bar owners, artists, and bar admins */}
              {(role === "bar_owner" ||
                role === "artist" ||
                role === "bar_admin") && (
                <>
                  <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      placeholder="Enter your full name"
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder="Enter your email"
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      placeholder="Enter your password"
                      disabled={loading}
                    />
                    <small className="form-hint">
                      Password must be at least 8 characters and include
                      uppercase, lowercase, number, and special character
                    </small>
                  </div>

                  <div className="form-group">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      placeholder="Confirm your password"
                      disabled={loading}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Creating account..." : "Sign Up"}
                  </button>
                </>
              )}
            </form>

            <div className="auth-links">
              <p>
                Already have an account? <Link to="/login">Sign in</Link>
              </p>
            </div>
          </>
        ) : (
          <div className="success-only-view">
            <div className="success-message large">{success}</div>
            <p className="redirect-message">Redirecting you to login...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;
